"use strict";

import angular from "angular";

angular.module("nucont.accounting.journey").config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    $stateProvider
        .state("nucont.accounting.journey", {
            url: "/jornada-onboarding",
            params: {
                from: { value: null, dynamic: true }
            },
            lazyLoad(transition) {
                const $ocLazyLoad = transition.injector().get("$ocLazyLoad");
                return import(
                    /* webpackChunkName: "feature-accounting-journey" */ "./journey.entry"
                ).then(() => $ocLazyLoad.inject("nucont.accounting.journey"));
            },
            data: {
                layoutConfig: {
                    model: "LayoutConfigModel4",
                    setAttrs: [
                        {
                            object: "headerConfig",
                            path: "closeTimes.enabled",
                            value: false
                        },
                        {
                            object: "headerConfig",
                            path: "featureNews.enabled",
                            value: true
                        },
                        {
                            object: "headerConfig",
                            path: "helpCentral.enabled",
                            value: true
                        }
                    ]
                }
            },
            views: {
                "admin@nucont.accounting": {
                    component: "accountingJourneyViewComponent"
                }
            }
        })
        .state("nucont.accounting.journey.import", {
            url: "/importacao?from",
            views: {
                "admin@nucont.accounting": {
                    component: "accountingJourneyImportViewComponent"
                }
            },
            params: {
                from: { value: null, dynamic: true }
            }
        })
        .state("nucont.accounting.journey.import.cadsim", {
            url: "/cadsim",
            views: {
                "submodules@nucont.accounting.journey.import": {
                    component: "cadsimImportViewComponent"
                }
            }
        })
        .state("nucont.accounting.journey.import.spreadsheet", {
            url: "/planilha",
            views: {
                "submodules@nucont.accounting.journey.import": {
                    component: "companiesSpreadsheetImportViewComponent"
                }
            }
        })
        .state("nucont.accounting.journey.import.document", {
            url: "/documento",
            views: {
                "submodules@nucont.accounting.journey.import": {
                    component: "documentImportViewComponent"
                }
            }
        })
        .state("nucont.accounting.journey.import.manualTable", {
            url: "/tabela",
            views: {
                "submodules@nucont.accounting.journey.import": {
                    component: "companiesManualTableImportViewComponent"
                }
            }
        })
        .state("nucont.accounting.journey.import.preview", {
            url: "/previa",
            params: {
                companyIds: { value: [], dynamic: true },
                contactsEmails: { value: [], dynamic: true }
            },
            views: {
                "admin@nucont.accounting": {
                    component: "accountingJourneyImportPreviewViewComponent"
                }
            }
        });
}
